module.exports = __webpack_public_path__ + "img/wckey.e48d5486.png";